import React, { useState, useEffect, useMemo, useContext } from "react";
import Header from "../commanComponents/userheader";
import Footer from "../commanComponents/userfooter";
import config from "../../coreFIles/config";
import { toast, Toaster } from "react-hot-toast";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import {
  getVehicleDetailActionbyid,
  insertvehicleBookingDetailsAction,
  getMMGJwt,
  MMGCheckoutPage,
  initiateVechileMMGPayment,
  checkVehicleTrxStatus,
  facPayment,
  checkCashbackBalance,
  checkSubsForDiscount,
} from "../../Action/user.action";
import {
  getSubscriptionPlanAction,
  InsertPaymentDetailsAction,
  checkPlanPurchaseAction,
  paymentIntentAction,
} from "../../Action/propertyOwner.action";
import {
  PayPalScriptProvider,
  PayPalButtons,
  FUNDING,
} from "@paypal/react-paypal-js";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Card,
  Modal,
  Spinner,
} from "react-bootstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { Buffer } from "buffer";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "../../generalPages/vehicleStripe";
import payment from "../commanComponents/componentCSS/payment.css";
import moment from "moment";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import $ from "jquery";
import { CurrencyContext } from "../../currencyConvertor/CurrencyContext";
import VehicleGuestForm from "./VehicleGuestForm";

const stripePromise = loadStripe(config.stripePrivateKey);
const VehiclePayment = () => {
  const loginData = !Cookies.get("loginSuccessPropertyOwner")
    ? []
    : JSON.parse(Cookies.get("loginSuccessPropertyOwner"));

  const { currency, convertPrice } = useContext(CurrencyContext);
  const navigate = useNavigate();
  // const { id, passenger, checkin, checkout } = useParams();
  const url = window.location.href;
  const params = new URLSearchParams(new URL(url).search);
  const id = params.get("id"); // "116"
  const checkin = params.get("checkin"); // "2024-11-22 12:46:00"
  const checkout = params.get("checkout"); // "2024-11-23 12:46:00"
  const passenger = Math.max(1, Number(params.get("passenger")) || 1);
  const gydPrice = Cookies.get("GYDPrice") || "Not Available";
  const [status, setStatus] = useState(false);
  const [guestData, setGuestData] = useState(null);
  const [loader, setLoader] = useState(true);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [subsDetail, setSubsDetail] = useState({});
  const [isVehicleOwner, setIsVehicleOwner] = useState(0);
  const [discount, setDiscount] = useState(0);

  const [vehicleDetail, setvehicleDetail] = useState({
    PropertyName: "",
    engineArr: [],
    bikeParking: "",
    carParking: "",
    categoryName: "",
    checkIn: "",
    checkOut: "",
    datetime: "",
    description: "",
    documentArr: [],
    email: "",
    guestCount: "",
    id: "",
    imageArr: [],
    isDeleted: "",
    location: "",
    numberOfBathroom: "",
    numberOfBedrooms: "",
    numberOfBeds: "",
    petsAllowed: "",
    price: "",
    propertyName: "",
    propertyPurchaseType: "",
    propertyPurchaseTypeId: "",
    status: "",
    terms: "",
  });
  const [imagesArr, setimagesArr] = useState([]);
  const [engineArr, setengineArr] = useState([]);
  const [totalBookingHour, settotalBookingHour] = useState(0);
  const [paymentType, setpaymentType] = useState(1); //1=Card ,2=Bank Transfer ,3=Paypal,4=Stripe,5=MMG
  const [clientSecret, setClientSecret] = useState("");
  const [chooseplanDetails, setChoosePlanDetails] = useState({
    description: "",
  });
  const [totalAmount, settotalAmount] = useState(0);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    getListingDetails();
    fetchCashbackBalance();
    fetchSubsForDiscount();
  }, []);

  const fetchSubsForDiscount = async () => {
    try {
      const res = await checkSubsForDiscount();
      if (res.success && res.data) {
        setSubsDetail(res.data);
        setIsVehicleOwner(1);
      } else {
        setSubsDetail(null);
        setIsVehicleOwner(0);
      }
    } catch (error) {
      console.error("Error fetching subscription detail:", error);
      setIsVehicleOwner(0);
    }
  };

  const getListingDetails = async () => {
    let res = await getVehicleDetailActionbyid({ id: id });
    if (res.success) {
      setvehicleDetail(res.data);
      setimagesArr(JSON.parse(res.data.imageArr));
      setengineArr(res.data.engineArr);
      setLoader(false);
    }
    if (checkin && checkout) {
      //Difference in number of days
      var date1 = new Date(checkin);
      var date2 = new Date(checkout);

      const getHoursDiffBetweenDates = (dateInitial, dateFinal) =>
        (dateFinal - dateInitial) / (1000 * 3600);
      const hour = parseFloat(getHoursDiffBetweenDates(date1, date2)).toFixed(
        0,
      );
      let inDays = Math.ceil(hour / 24);
      settotalBookingHour(inDays);
    }
  };

  const paymentIntent = async () => {
    let amount = (
      parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour) +
      parseFloat(vehicleDetail.securityDeposit)
    ).toFixed(2);

    let res = await paymentIntentAction({ amount: amount });
    if (res.success) {
      setClientSecret({
        clientSecret: Buffer.from(res.client_secret, "base64").toString(
          "ascii",
        ),
      });
    }
  };

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>    PAYPAL PAYMENT  START   >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

  const calculateFinalAmount = () => {
    // Calculate base amount
    const baseAmount =
      parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour);
    const securityDeposit = parseFloat(vehicleDetail.securityDeposit);
    let totalAmount = baseAmount + securityDeposit;

    let discountAmount = 0;
    let cashbackAmount = 0;

    // Apply discount if user is a vehicle owner with subscription
    if (isVehicleOwner === 1 && subsDetail?.bookingDiscount > 0) {
      discountAmount = (totalAmount * (subsDetail.bookingDiscount || 0)) / 100;
      totalAmount -= discountAmount;
    }

    // Apply cashback and discount for non-vehicle owners
    if (isVehicleOwner === 0) {
      // Apply subscription discount first
      if (subsDetail?.bookingDiscount > 0) {
        const discount =
          (totalAmount * (subsDetail.bookingDiscount || 0)) / 100;
        discountAmount = discount;
        totalAmount -= discount;
      }

      // Then apply cashback
      if (useCashback) {
        const maxCashback = Math.min(cashbackBalance, totalAmount * 0.5);
        cashbackAmount = maxCashback;
        totalAmount -= cashbackAmount;
      }
    }

    // Ensure totalAmount doesn't go below 0
    return {
      finalAmount: Math.max(0, totalAmount),
      discountAmount,
      cashbackAmount,
      baseAmount,
    };
  };

  const createOrder = (data, actions) => {
    const { finalAmount } = calculateFinalAmount();
    return actions.order
      .create({
        purchase_units: [
          {
            description: chooseplanDetails.description,
            amount: {
              currency_code: "USD",
              value: finalAmount.toFixed(2),
            },
          },
        ],
      })
      .then((orderID) => {
        return orderID;
      });
  };

  const onApprove = (data, actions) => {
    setIsProcessingPayment(true);

    let amount = (
      parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour) +
      parseFloat(vehicleDetail.securityDeposit)
    ).toFixed(2);

    const { finalAmount } = calculateFinalAmount();

    return actions.order.capture().then(async function (res) {
      if (res.status == "COMPLETED") {
        let arr = {
          vehicleId: parseInt(id),
          paymentMethodId: 1,
          checkInDate: checkin,
          checkOutDate: checkout,
          passenger: passenger,
          checkInTime:
            ("0" + new Date(checkin).getHours()).slice(-2) +
            ":" +
            ("0" + new Date(checkout).getMinutes()).slice(-2),
          checkOutTime:
            ("0" + new Date(checkout).getHours()).slice(-2) +
            ":" +
            ("0" + new Date(checkout).getMinutes()).slice(-2),
          locationPickup: true,
          amount: amount,
          securityDeposit: parseFloat(vehicleDetail.securityDeposit),
          status: 1,
          upiId: "",
          paymentResponse: res,
          orderId: res.id,
          guestDetail: guestData,
          baseAmt:
            parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
          isCashbackApplied: useCashback == true ? 1 : 0,
          cashbackApplied: cashbackApplied,
          finalAmount: finalAmount,
          discountPercent: subsDetail?.bookingDiscount || 0,
          discountAmount: discount || 0,
          isVehicleOwner: isVehicleOwner,
        };

        let result = "";
        result = await insertvehicleBookingDetailsAction(arr);
        if (result.success) {
          toast.success(result.msg);

          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/vehicleBooking`);
          }, 2000);
        } else {
          setIsProcessingPayment(false);

          toast.error(result.msg);
        }
      } else {
        setIsProcessingPayment(false);

        toast.error(
          "Something went wrong with your payment. Please try again after some time",
        );
      }
    });
  };

  const onError = (data, actions) => {
    toast.error(
      "Something went wrong with your payment. Please try again after some time",
    );
  };

  const disableStripe = () => {
    setClientSecret("");
  };

  useMemo(() => {
    if (paymentType == 2) {
      paymentIntent();
    }
  }, [paymentType]);

  const createPdfFile = () => {
    var HTML_Width = $(".html-content").width();
    var HTML_Height = $(".html-content").height();
    var top_left_margin = 15;
    var PDF_Width = HTML_Width + top_left_margin * 2;
    var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
    var canvas_image_width = HTML_Width;
    var canvas_image_height = HTML_Height;

    var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

    html2canvas($(".html-content")[0]).then(function (canvas) {
      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
      pdf.addImage(
        imgData,
        "JPG",
        top_left_margin,
        top_left_margin,
        canvas_image_width,
        canvas_image_height,
      );
      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(PDF_Width, PDF_Height);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          -(PDF_Height * i) + top_left_margin * 4,
          canvas_image_width,
          canvas_image_height,
        );
      }
      pdf.save("Your_PDF_Name.pdf");
      // $(".html-content").hide();
    });
  };

  //---------------------------|| MMG Payment API ||---------------------------

  const [isPaymentInitiated, setIsPaymentInitiated] = useState(false);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [timeLeft, setTimeLeft] = useState(600);
  const [timerStarted, setTimerStarted] = useState(false);
  const [referenceId, setReferenceId] = useState("");
  const [isCustomerIdInvalid, setIsCustomerIdInvalid] = useState(false);
  const [merchantData, setMerchantData] = useState({});
  const [showInt, setIntShow] = useState(false);

  const handleIntClose = () => {
    setIntShow(false);
    setIsPaymentInitiated(false);
  };
  const handleIntShow = () => setIntShow(true);

  useEffect(() => {
    let timer;

    if (timerStarted && timeLeft > 0) {
      timer = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      fetchTransactionStatus();
    }
    if (timeLeft === 0) {
      setTimerStarted(false);
      setShowNoteModal(false);
      setTimeLeft(600);
    }

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [timerStarted, timeLeft]);

  const formatTime = (seconds) => {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return `${min.toString().padStart(2, "0")}:${sec.toString().padStart(2, "0")}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setMerchantData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "customerId") {
      setIsCustomerIdInvalid(value.trim() === "");
    }
  };

  const fetchTransactionStatus = async () => {
    try {
      const response = await checkVehicleTrxStatus({ referenceId });
      if (response.success) {
        if (response.data.transactionStatus === "successful") {
          setTimerStarted(false);
          setShowNoteModal(false);
          setTimeLeft(600);
          toast.success("Payment successful!");
          setTimeout(() => {
            navigate(`${config.baseUrl}userdashboard/vehicleBooking`);
          }, 5000);
        } else if (response.data.transactionStatus === "failed") {
          toast.error("Payment failed.");
          setTimerStarted(false);
          setShowNoteModal(false);
          setTimeLeft(600);
        }
      }
    } catch (error) {
      console.error("Error fetching transaction status:", error);
      toast.error("Failed to fetch transaction status. Please try again.");
    }
  };

  const MMGPayment = async () => {
    if (!merchantData.customerId) {
      setIsCustomerIdInvalid(true);
      return;
    }
    setIsPaymentInitiated(true);

    try {
      let amount =
        (parseFloat(vehicleDetail.perHourRate) * parseFloat(totalBookingHour) +
          parseFloat(vehicleDetail.securityDeposit)) *
        gydPrice;
      let usdAmount =
        parseFloat(vehicleDetail.perHourRate) * parseFloat(totalBookingHour) +
        parseFloat(vehicleDetail.securityDeposit);

      let arr = {
        vehicleId: parseInt(id),
        paymentMethodId: 1,
        checkInDate: checkin,
        checkOutDate: checkout,
        passenger: passenger,
        checkInTime:
          ("0" + new Date(checkin).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(checkout).getMinutes()).slice(-2),
        checkOutTime:
          ("0" + new Date(checkout).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(checkout).getMinutes()).slice(-2),
        locationPickup: true,
        amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2),
        usdAmount: parseFloat(String(usdAmount).replace(/,/g, "")).toFixed(2),
        securityDeposit: parseFloat(vehicleDetail.securityDeposit),
        status: 1,
        upiId: "",
        guestDetail: guestData,
        userId: loginData?.id,
        customerId: merchantData.customerId,
        baseAmt:
          parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: subsDetail?.bookingDiscount || 0,
        discountAmount: discount || 0,
        isVehicleOwner: isVehicleOwner,
      };

      const res = await initiateVechileMMGPayment(arr);
      if (res.success) {
        setIsPaymentInitiated(true);
        setReferenceId(res?.transactionData?.objectReference);
        toast.success(res.message);
        setTimeLeft(600);
        setTimerStarted(true);
        setShowNoteModal(true);
        handleIntClose();
      } else {
        setIsPaymentInitiated(false);
        if (res.message.message) {
          toast.error(res.message.message || "Payment initiation failed");
        } else {
          toast.error("Payment initiation failed");
        }
        handleClose();
      }
    } catch (error) {
      setIsPaymentInitiated(false);
      console.error("Error during MMG payment:", error);
      toast.error("Failed to process MMG payment. Please try again.");
    }
  };

  //---------------------------|| FAC Payment API ||---------------------------//

  const [Facshow, setFacShow] = useState(false);
  const [checkoutForm, setCheckoutForm] = useState({
    cardholderName: "",
    cardNumber: "",
    expiryDate: "",
    cvv: "",
    amount: "",
  });

  const [emptyFields, setEmptyFields] = useState([]);
  const handleFacClose = () => {
    setCheckoutForm({});
    setFacShow(false);
    setEmptyFields([]);
  };
  const handleFacShow = () => setFacShow(true);

  const handleFACChange = (e) => {
    const { id, value } = e.target;
    setCheckoutForm({ ...checkoutForm, [id]: value });

    if (emptyFields.includes(id)) {
      setEmptyFields(emptyFields.filter((field) => field !== id));
    }
  };

  const handleFACPayment = async (e) => {
    e.preventDefault();
    const requiredFields = [
      "cardholderName",
      "cardNumber",
      "expiryDate",
      "cvv",
    ];

    const missingFields = requiredFields.filter(
      (field) => !checkoutForm[field] || checkoutForm[field].trim() === "",
    );

    if (missingFields.length > 0) {
      setEmptyFields(missingFields);
      return;
    }
    try {
      let amount =
        parseFloat(vehicleDetail.perHourRate) * parseFloat(totalBookingHour) +
        parseFloat(vehicleDetail.securityDeposit);

      let arr = {
        vehicleId: parseInt(id),
        paymentMethodId: 1,
        checkInDate: checkin,
        checkOutDate: checkout,
        passenger: passenger,
        checkInTime:
          ("0" + new Date(checkin).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(checkout).getMinutes()).slice(-2),
        checkOutTime:
          ("0" + new Date(checkout).getHours()).slice(-2) +
          ":" +
          ("0" + new Date(checkout).getMinutes()).slice(-2),
        locationPickup: true,
        amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2),
        securityDeposit: parseFloat(vehicleDetail.securityDeposit),
        status: 1,
        upiId: "",
        guestDetail: guestData,
        userId: loginData?.id,
        customerId: merchantData.customerId,
        bookingFor: 2, // 2 for vehicle booking
        checkOutDetails: checkoutForm,
        baseAmt:
          parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        finalAmount: finalAmount,
        discountPercent: subsDetail?.bookingDiscount || 0,
        discountAmount: discount || 0,
        isVehicleOwner: isVehicleOwner,
      };
      let res = await facPayment(arr);

      if (res.data && res.data.RedirectData) {
        setCheckoutForm({});
        setFacShow(false);
        setEmptyFields([]);
        const redirectHTML = res.data.RedirectData;

        const blob = new Blob([redirectHTML], { type: "text/html" });
        const url = URL.createObjectURL(blob);

        // Open in the same window/tab
        window.location.href = url;
      } else {
        alert("No redirect data received for 3DS authentication.");
      }
    } catch (error) {
      console.error("Error during FAC payment:", error);
      alert("Payment initiation failed.");
    }
  };

  //---------------------------|| Cashback Balance ||---------------------------//

  const [cashbackBalance, setCashbackBalance] = useState(0);
  const [useCashback, setUseCashback] = useState(false);
  const [cashbackApplied, setCashbackApplied] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);

  const fetchCashbackBalance = async () => {
    try {
      const res = await checkCashbackBalance();
      if (res.success) {
        setCashbackBalance(res.data.balance);
      }
    } catch (error) {
      console.error("Error fetching cashback balance:", error);
    }
  };

  const calculateTotalAmount = () => {
    if (vehicleDetail.perHourRate && totalBookingHour) {
      const totalAmount =
        parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour) +
        parseFloat(vehicleDetail.securityDeposit);
      return totalAmount;
    } else {
      return totalAmount;
    }
  };

  const calculateMaxCashback = () => {
    const totalAmount = calculateTotalAmount();
    // Maximum cashback is 50% of total or available balance, whichever is lower
    const maxCashback = Math.min(cashbackBalance, totalAmount * 0.5);
    return maxCashback;
  };

  const handleCashbackChange = (e) => {
    const shouldUseCashback = e.target.checked;
    setUseCashback(shouldUseCashback);

    if (shouldUseCashback) {
      const maxCashback = calculateMaxCashback();
      setCashbackApplied(maxCashback);

      // Calculate final amount after cashback
      const totalAmount = calculateTotalAmount();
      setFinalAmount(Math.max(0, totalAmount - maxCashback));
    } else {
      setCashbackApplied(0);
      setFinalAmount(calculateTotalAmount());
    }
  };

  useEffect(() => {
    const { finalAmount, discountAmount, cashbackAmount } =
      calculateFinalAmount();
    setFinalAmount(finalAmount);
    setDiscount(discountAmount);
    setCashbackApplied(cashbackAmount);
  }, [
    vehicleDetail,
    totalBookingHour,
    isVehicleOwner,
    subsDetail,
    useCashback,
    cashbackBalance,
  ]);

  // ---------------------------|| MMG Checkout ||---------------------------//
  const [MMGToken, setMMGToken] = useState("");


  const getMMGPayloadAPI = async (data) => {
    const encryptionKey = config.fygaroJWTEncryptionKey;
    let amount = (
      parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour) +
      parseFloat(vehicleDetail.securityDeposit)
    ).toFixed(2);

    const { finalAmount } = calculateFinalAmount();

    let mmgPayload = {
      vehicleId: parseInt(id),
      paymentMethodId: 1,
      checkInDate: checkin,
      checkOutDate: checkout,
      passengers: passenger,
      checkInTime:
        ("0" + new Date(checkin).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(checkout).getMinutes()).slice(-2),
      checkOutTime:
        ("0" + new Date(checkout).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(checkout).getMinutes()).slice(-2),
      locationPickup: 1,
      amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2)*parseFloat(gydPrice).toFixed(2),

      
      securityDeposit: parseFloat(vehicleDetail.securityDeposit),
      status: 1,
      upiId: "",
      guestDetail: guestData,
      userId: loginData?.id,
      customerId: merchantData.customerId,
      baseAmt:
        parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
      isCashbackApplied: useCashback == true ? 1 : 0,
      cashbackApplied: cashbackApplied,
      finalAmount: finalAmount,
      discountPercent: subsDetail?.bookingDiscount || 0,
      discountAmount: discount || 0,
      isVehicleOwner: isVehicleOwner,
      type: 2,
    };
console.log("MMG Payload before encryption:", mmgPayload);
    const encryptedPayload = CryptoJS.AES.encrypt(
      JSON.stringify(mmgPayload),
      encryptionKey,
    ).toString();

    let jwtReceived = await getMMGJwt({ jwt: encryptedPayload });

    if (jwtReceived.success) {
      setMMGToken(jwtReceived.data);
      return jwtReceived.data;
    }
  };

  const MMGCheckout = async (data, actions) => {
    let amount = (
      parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour) +
      parseFloat(vehicleDetail.securityDeposit)
    ).toFixed(2);

    const { finalAmount } = calculateFinalAmount();

    let arr = {
      vehicleId: parseInt(id),
      paymentMethodId: 1,
      checkInDate: checkin,
      checkOutDate: checkout,
      passengers: passenger || 1,
      checkInTime:
        ("0" + new Date(checkin).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(checkout).getMinutes()).slice(-2),
      checkOutTime:
        ("0" + new Date(checkout).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(checkout).getMinutes()).slice(-2),
      locationPickup: 1,
      amount: parseFloat(String(amount).replace(/,/g, "")).toFixed(2)*parseFloat(gydPrice).toFixed(2),
      securityDeposit: parseFloat(vehicleDetail.securityDeposit),
      status: 1,  
      upiId: "",
      guestDetail: guestData,
      userId: loginData?.id,
      customerId: merchantData.customerId,
      baseAmt:
        parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
      isCashbackApplied: useCashback == true ? 1 : 0,
      cashbackApplied: cashbackApplied,
      finalAmount: finalAmount,
      discountPercent: subsDetail?.bookingDiscount || 0,
      discountAmount: discount || 0,
      isVehicleOwner: isVehicleOwner,
    };

    let mmgPayLoadData = {
      vehicleDetail: {
        ...vehicleDetail, // existing data

        isCashbackApplied: useCashback == true ? 1 : 0,
        cashbackApplied: cashbackApplied,
        discountPercent: subsDetail?.bookingDiscount || 0,
        discountAmount: discount || 0,
        baseAmt:
          parseFloat(vehicleDetail.perHourRate) * parseInt(totalBookingHour),
        isPropertyOwner: isVehicleOwner,
        finalAmount: finalAmount,
      },

      guestDetail: guestData,
    };
    let token =await getMMGPayloadAPI(mmgPayLoadData);

    console.log("MMG Checkout Payload:", JSON.stringify(arr));
    localStorage.setItem("vehicleDetails", JSON.stringify(arr));

    const response = await MMGCheckoutPage({ jwt: token });

    if (response && response.data && response.data.redirectUrl) {
      window.open(response.data.redirectUrl, "_blank");
    } else {
      toast.error("Failed to retrieve the checkout URL. Please try again.");
    }
  };

  return (
    <>
      <Header />
      {loader ? (
        <div className="loader-container">
          <img
            src="assets/images/loader-home.gif"
            style={{ height: "100px", width: "100px" }}
          />
        </div>
      ) : (
        <div>
          <Toaster />
          {isProcessingPayment && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "8px",
                  textAlign: "center",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Spinner animation="border" variant="primary" />
                <p className="mt-3">Processing your payment...</p>
              </div>
            </div>
          )}
          <section className="yourbooking pt-5 pb-5 overflow-hidden vh-80">
            <Container>
              <div className="">
                <Row className=" ">
                  <Col lg={7} className="mb-4">
                    <VehicleGuestForm
                      onStatusChange={(status) => setStatus(status)}
                      onSubmitFormData={(data) => setGuestData(data)}
                    />

                    {status === true && (
                      <div>
                        <div className="heading border-bottom border-secondary pt-2 pb-2">
                          <h5>
                            <b>Payment</b>
                          </h5>
                        </div>
                        <div className="mt-4">
                          <h6 className="mb-2">
                            <b>Pay With:</b>
                          </h6>
                          {/* <Form>
                            {["radio"].map((type) => (
                              <div key={`inline-${type}`} className="mb-3">

                                <Form.Check
                                  inline
                                  label="PayPal"
                                  onChange={(e) => setpaymentType(1)}
                                  checked={paymentType == 1}
                                  name="group1"
                                  type={type}
                                  id={`inline-${type}-3`}
                                  className="me-3"
                                />
                              </div>
                            ))}
                          </Form> */}
                        </div>

                        {/* <button
                          className="d-flex align-items-center fw-bold justify-content-center btn paypal-button w-100 mt-2"
                          onClick={handleIntShow}
                          disabled={timerStarted}
                        >
                          <img
                            src="images/mmg-logo.png"
                            alt="MMG Logo"
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                          MMG
                        </button> */}

                        <button
                          className="d-flex align-items-center fw-bold justify-content-center btn paypal-button w-100 mt-2"
                          onClick={MMGCheckout}
                        >
                          <img
                            src="images/mmg-logo.png"
                            alt=""
                            style={{ height: "25px", marginRight: "8px" }}
                          />
                          MMG
                        </button>
                        <br />

                        {/* <button
                          style={{ backgroundColor: '#007bff', color: 'white' }}
                          className="d-flex align-items-center fw-bold justify-content-center btn w-100 mt-2"
                          disabled={timerStarted}
                          onClick={handleFacShow}
                        >
                          Credit / Debit Card
                        </button>
                        <br /> */}

                        {paymentType == 1 && vehicleDetail.perHourRate > 0 ? (
                          <PayPalScriptProvider
                            options={{
                              "client-id": config.CLIENT_ID,
                              components: "buttons",
                              intent: "capture",
                              "disable-funding": "venmo,paylater",
                            }}
                          >
                            <PayPalButtons
                              style={{ layout: "vertical" }}
                              className="paypal-buttons"
                              onClick={disableStripe}
                              createOrder={createOrder}
                              onApprove={onApprove}
                              onError={onError}
                              disabled={timerStarted}
                              forceReRender={[
                                finalAmount,
                                useCashback,
                                isVehicleOwner,
                                subsDetail,
                                cashbackBalance,
                              ]}
                            />
                          </PayPalScriptProvider>
                        ) : clientSecret && paymentType == 2 ? (
                          <Elements
                            stripe={stripePromise}
                            options={clientSecret}
                          >
                            <div
                              className="text-center"
                              style={{ padding: "15px" }}
                            >
                              <CheckoutForm
                                data={{
                                  vehicleId: parseInt(id),
                                  paymentMethodId: 1,
                                  checkInDate: checkin,
                                  checkOutDate: checkout,
                                  passenger: passenger,
                                  checkInTime:
                                    new Date(checkin).getHours() +
                                    ":" +
                                    new Date(checkout).getMinutes(),
                                  checkOutTime:
                                    new Date(checkout).getHours() +
                                    ":" +
                                    new Date(checkout).getMinutes(),
                                  locationPickup: true,
                                  amount:
                                    parseInt(vehicleDetail.perHourRate) *
                                    parseInt(totalBookingHour),
                                  status: 1,
                                  upiId: "",
                                }}
                              />
                            </div>
                          </Elements>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </Col>
                  <Col lg={5} className="mb-4">
                    {timerStarted ? (
                      <h5>
                        Time Remaining:{" "}
                        <span className="text-danger">
                          {formatTime(timeLeft)} Minutes
                        </span>
                      </h5>
                    ) : (
                      ""
                    )}

                    <Card>
                      <div className="paymentImg">
                        {imagesArr.length > 0 ? (
                          <img src={`${imagesArr[0].fileNameImage}`} />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="px-2">
                        <div>
                          <div className="mt-4">
                            <div className="">
                              <h5 className="mb-2">
                                <b>{vehicleDetail.vehicleName}</b>
                              </h5>
                              <div className="d-flex justify-content-between">
                                <div>
                                  <h6>{vehicleDetail.location}</h6>
                                </div>
                                <h5>
                                  {" "}
                                  <b>
                                    $
                                    {convertPrice(
                                      parseFloat(vehicleDetail.perHourRate) *
                                        parseInt(totalBookingHour) +
                                        parseFloat(
                                          vehicleDetail.securityDeposit,
                                        ),
                                    )}{" "}
                                    {currency}
                                  </b>
                                </h5>
                              </div>
                            </div>
                          </div>
                          <hr />

                          <div className="">
                            <Row>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>Start Date</b>
                                  </div>
                                  <p className="text-grey mb-0">{checkin}</p>
                                </div>
                              </Col>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>End Date</b>
                                  </div>
                                  <p className="text-grey mb-0">{checkout}</p>
                                </div>
                              </Col>
                              <Col lg={4} className="">
                                <div>
                                  <div>
                                    <b>Days</b>
                                  </div>
                                  <p className="text-grey mb-0">
                                    {totalBookingHour} Days
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </div>
                          <hr />
                          <div className="mt-4 mb-4">
                            <Row>
                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>
                                  <td>
                                    {" "}
                                    ${parseInt(
                                      vehicleDetail.perHourRate,
                                    )} X {parseInt(totalBookingHour)} Days
                                  </td>
                                </h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  $
                                  {convertPrice(
                                    parseFloat(vehicleDetail.perHourRate) *
                                      parseInt(totalBookingHour),
                                  )}{" "}
                                  {currency}
                                </span>
                              </Col>
                              <Col lg={6} sm={6} xs={6} className="mb-2">
                                <h6>Security Deposit</h6>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <span className="text-grey">
                                  ${convertPrice(vehicleDetail.securityDeposit)}{" "}
                                  {currency}
                                </span>
                              </Col>
                              <Col lg={6} sm={6} xs={6} className="mb-2 ">
                                <h5>
                                  <b>Total Cost:</b>
                                </h5>
                              </Col>
                              <Col
                                lg={6}
                                sm={6}
                                xs={6}
                                className="mb-2 text-right"
                              >
                                <h5 className="text-grey">
                                  $
                                  {(() => {
                                    const totalAmount =
                                      parseFloat(vehicleDetail.perHourRate) *
                                        parseInt(totalBookingHour) +
                                      parseFloat(vehicleDetail.securityDeposit);

                                    return `${convertPrice(totalAmount)} ${currency}`;
                                  })()}
                                </h5>
                              </Col>

                              {isVehicleOwner === 1 &&
                                subsDetail?.bookingDiscount > 0 && (
                                  <>
                                    <Row className="mb-2">
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2"
                                      >
                                        <h6>
                                          Discount ({subsDetail.bookingDiscount}
                                          %)
                                        </h6>
                                      </Col>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2 text-right"
                                      >
                                        <span className="text-success">
                                          {(() => {
                                            const totalAmount =
                                              parseFloat(
                                                vehicleDetail.perHourRate,
                                              ) *
                                                parseInt(totalBookingHour) +
                                              parseFloat(
                                                vehicleDetail.securityDeposit,
                                              );

                                            const discount =
                                              (parseFloat(totalAmount) *
                                                (subsDetail?.bookingDiscount ||
                                                  0)) /
                                              100;

                                            return `-${convertPrice(discount)} ${currency}`;
                                          })()}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="mt-2">
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2"
                                      >
                                        <h5>
                                          <b>Final Amount:</b>
                                        </h5>
                                      </Col>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2 text-right"
                                      >
                                        <h5 className="fw-bold text-dark">
                                          {(() => {
                                            const totalAmount =
                                              parseFloat(
                                                vehicleDetail.perHourRate,
                                              ) *
                                                parseInt(totalBookingHour) +
                                              parseFloat(
                                                vehicleDetail.securityDeposit,
                                              );

                                            const discount =
                                              (parseFloat(totalAmount) *
                                                (subsDetail?.bookingDiscount ||
                                                  0)) /
                                              100;

                                            const finalAmount =
                                              totalAmount - discount;

                                            return `$${convertPrice(finalAmount)} ${currency}`;
                                          })()}
                                        </h5>
                                      </Col>
                                    </Row>
                                  </>
                                )}

                              {isVehicleOwner === 0 ? (
                                <>
                                  {cashbackBalance > 0 && (
                                    <Row className="mt-3">
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2"
                                      >
                                        <div className="d-flex align-items-center">
                                          <Form.Check
                                            type="checkbox"
                                            id="use-cashback"
                                            checked={useCashback}
                                            onChange={handleCashbackChange}
                                            className="me-2"
                                          />
                                          <Form.Label
                                            htmlFor="use-cashback"
                                            className="mb-0"
                                          >
                                            Use Cashback Balance
                                          </Form.Label>
                                        </div>
                                        <small className="text-muted">
                                          Available: $
                                          {convertPrice(cashbackBalance)}{" "}
                                          {currency}
                                        </small>
                                      </Col>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2 text-right"
                                      >
                                        {useCashback ? (
                                          <span className="text-success">
                                            -${convertPrice(cashbackApplied)}{" "}
                                            {currency}
                                          </span>
                                        ) : (
                                          <span className="text-grey">
                                            ${convertPrice(0)} {currency}
                                          </span>
                                        )}
                                      </Col>
                                    </Row>
                                  )}

                                  {subsDetail?.bookingDiscount > 0 && (
                                    <Row className="mb-2">
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2"
                                      >
                                        <h6>
                                          Discount ({subsDetail.bookingDiscount}
                                          %)
                                        </h6>
                                      </Col>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2 text-right"
                                      >
                                        <span className="text-success">
                                          {(() => {
                                            const totalAmount =
                                              parseFloat(
                                                vehicleDetail.perHourRate,
                                              ) *
                                                parseInt(totalBookingHour) +
                                              parseFloat(
                                                vehicleDetail.securityDeposit,
                                              );

                                            const discount =
                                              (parseFloat(totalAmount) *
                                                (subsDetail?.bookingDiscount ||
                                                  0)) /
                                              100;

                                            return `-${convertPrice(discount)} ${currency}`;
                                          })()}
                                        </span>
                                      </Col>
                                    </Row>
                                  )}

                                  {(useCashback ||
                                    subsDetail?.bookingDiscount > 0) && (
                                    <Row>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2"
                                      >
                                        <h5>
                                          <b>Final Amount:</b>
                                        </h5>
                                      </Col>
                                      <Col
                                        lg={6}
                                        sm={6}
                                        xs={6}
                                        className="mb-2 text-right"
                                      >
                                        <h5 className="fw-bold text-dark">
                                          {(() => {
                                            const totalAmount =
                                              parseFloat(
                                                vehicleDetail.perHourRate,
                                              ) *
                                                parseInt(totalBookingHour) +
                                              parseFloat(
                                                vehicleDetail.securityDeposit,
                                              );

                                            const discount =
                                              (parseFloat(totalAmount) *
                                                (subsDetail?.bookingDiscount ||
                                                  0)) /
                                              100;

                                            let finalAmount =
                                              totalAmount - discount;

                                            if (useCashback) {
                                              finalAmount -= parseFloat(
                                                cashbackApplied || 0,
                                              );
                                            }

                                            return `$${convertPrice(finalAmount)} ${currency}`;
                                          })()}
                                        </h5>
                                      </Col>
                                    </Row>
                                  )}
                                </>
                              ) : null}
                            </Row>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                </Row>
              </div>
            </Container>
          </section>
        </div>
      )}
      <Footer />
      <Modal show={show} onHide={handleClose} size="md">
        <Modal.Header closeButton>
          <Modal.Title>
            <b>Invoice Details</b>
          </Modal.Title>
          <div style={{ "margin-left": "25px" }}>
            <button
              className="btn btn-primary h-auto btn-sm rounded-1"
              onClick={createPdfFile}
            >
              Download
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="px-2">
            <div>
              <div className="mt-4">
                <div className="">
                  <h5 className="mb-2">
                    <b>{vehicleDetail.vehicleName}</b>
                  </h5>
                  <div className="d-flex justify-content-between">
                    <div>
                      <h6>{vehicleDetail.location}</h6>
                    </div>
                    <h5>
                      {" "}
                      <b>
                        $
                        {parseInt(vehicleDetail.perHourRate) *
                          parseInt(totalBookingHour)}
                      </b>
                    </h5>
                  </div>
                </div>
              </div>
              <hr />

              <div className="">
                <Row>
                  <Col lg={4} className="">
                    <div>
                      <div>
                        <b>Start Date</b>
                      </div>
                      <p className="text-grey mb-0">{checkin}</p>
                    </div>
                  </Col>
                  <Col lg={4} className="">
                    <div>
                      <div>
                        <b>End Date</b>
                      </div>
                      <p className="text-grey mb-0">{checkout}</p>
                    </div>
                  </Col>
                  <Col lg={4} className="">
                    <div>
                      <div>
                        <b>Days</b>
                      </div>
                      <p className="text-grey mb-0">{totalBookingHour} Days</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <hr />
              <div className="mt-4 mb-4">
                <Row>
                  <Col lg={6} sm={6} xs={6} className="mb-2">
                    <h6>
                      <td>
                        {" "}
                        ${parseInt(vehicleDetail.perHourRate)} X{" "}
                        {parseInt(totalBookingHour)} Days
                      </td>
                    </h6>
                  </Col>
                  <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                    <span className="text-grey">
                      $
                      {parseInt(vehicleDetail.perHourRate) *
                        parseInt(totalBookingHour)}
                    </span>
                  </Col>
                  <Col lg={6} sm={6} xs={6} className="mb-2">
                    <h6>Tax Fees</h6>
                  </Col>
                  <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                    <span className="text-grey">$0</span>
                  </Col>
                  <Col lg={6} sm={6} xs={6} className="mb-2 ">
                    <h5>
                      <b>Total Cost:</b>
                    </h5>
                  </Col>

                  <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                    <h5 className="text-grey">
                      $
                      {parseInt(vehicleDetail.perHourRate) *
                        parseInt(totalBookingHour)}
                    </h5>
                  </Col>
                  {isVehicleOwner === 1 && subsDetail?.bookingDiscount > 0 && (
                    <>
                      <Row className="mb-2">
                        <Col lg={6} sm={6} xs={6} className="mb-2">
                          <h6>Discount ({subsDetail.bookingDiscount}%)</h6>
                        </Col>
                        <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                          <span className="text-success">
                            {(() => {
                              const totalAmount =
                                parseFloat(vehicleDetail.perHourRate) *
                                  parseInt(totalBookingHour) +
                                parseFloat(vehicleDetail.securityDeposit);

                              const discount =
                                (parseFloat(totalAmount) *
                                  (subsDetail?.bookingDiscount || 0)) /
                                100;

                              return `-${convertPrice(discount)} ${currency}`;
                            })()}
                          </span>
                        </Col>
                      </Row>

                      <Row className="mt-2">
                        <Col lg={6} sm={6} xs={6} className="mb-2">
                          <h5>
                            <b>Final Amount:</b>
                          </h5>
                        </Col>
                        <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                          <h5 className="fw-bold text-dark">
                            {(() => {
                              const totalAmount =
                                parseFloat(vehicleDetail.perHourRate) *
                                  parseInt(totalBookingHour) +
                                parseFloat(vehicleDetail.securityDeposit);

                              const discount =
                                (parseFloat(totalAmount) *
                                  (subsDetail?.bookingDiscount || 0)) /
                                100;

                              const finalAmount = totalAmount - discount;

                              return `$${convertPrice(finalAmount)} ${currency}`;
                            })()}
                          </h5>
                        </Col>
                      </Row>
                    </>
                  )}

                  {isVehicleOwner === 0 ? (
                    <>
                      {cashbackBalance > 0 && (
                        <Row className="mt-3">
                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <div className="d-flex align-items-center">
                              <Form.Check
                                type="checkbox"
                                id="use-cashback"
                                checked={useCashback}
                                onChange={handleCashbackChange}
                                className="me-2"
                              />
                              <Form.Label
                                htmlFor="use-cashback"
                                className="mb-0"
                              >
                                Use Cashback Balance
                              </Form.Label>
                            </div>
                            <small className="text-muted">
                              Available: ${convertPrice(cashbackBalance)}{" "}
                              {currency}
                            </small>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            {useCashback ? (
                              <span className="text-success">
                                -${convertPrice(cashbackApplied)} {currency}
                              </span>
                            ) : (
                              <span className="text-grey">
                                ${convertPrice(0)} {currency}
                              </span>
                            )}
                          </Col>
                        </Row>
                      )}

                      {subsDetail?.bookingDiscount > 0 && (
                        <Row className="mb-2">
                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h6>Discount ({subsDetail.bookingDiscount}%)</h6>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <span className="text-success">
                              {(() => {
                                const totalAmount =
                                  parseFloat(vehicleDetail.perHourRate) *
                                    parseInt(totalBookingHour) +
                                  parseFloat(vehicleDetail.securityDeposit);

                                const discount =
                                  (parseFloat(totalAmount) *
                                    (subsDetail?.bookingDiscount || 0)) /
                                  100;

                                return `-${convertPrice(discount)} ${currency}`;
                              })()}
                            </span>
                          </Col>
                        </Row>
                      )}

                      {(useCashback || subsDetail?.bookingDiscount > 0) && (
                        <Row>
                          <Col lg={6} sm={6} xs={6} className="mb-2">
                            <h5>
                              <b>Final Amount:</b>
                            </h5>
                          </Col>
                          <Col lg={6} sm={6} xs={6} className="mb-2 text-right">
                            <h5 className="fw-bold text-dark">
                              {(() => {
                                const totalAmount =
                                  parseFloat(vehicleDetail.perHourRate) *
                                    parseInt(totalBookingHour) +
                                  parseFloat(vehicleDetail.securityDeposit);

                                const discount =
                                  (parseFloat(totalAmount) *
                                    (subsDetail?.bookingDiscount || 0)) /
                                  100;

                                let finalAmount = totalAmount - discount;

                                if (useCashback) {
                                  finalAmount -= parseFloat(
                                    cashbackApplied || 0,
                                  );
                                }

                                return `$${convertPrice(finalAmount)} ${currency}`;
                              })()}
                            </h5>
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : null}
                </Row>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* ------Merchent Payment Modal-------- */}
      <Modal show={showInt} onHide={handleIntClose} size="md">
        <Modal.Header
          closeButton
          className="border-0 position-relative z-2"
        ></Modal.Header>
        <Modal.Body style={{ marginTop: "-38px" }}>
          <div className="text-center mb-3">
            <div className="mb-2">
              <img
                src="images/mmg-logo.png"
                alt="MMG Logo"
                style={{ height: "50px" }}
              />
            </div>
            <h4 className="fw-semibold mb-2">Initiate Payment</h4>
            <h6 className="fw-semibold mb-2">Property Nu</h6>
            {/* <h6 className="fw-semibold mb-2"><span className="text-primary">Total Amount:</span> {parseFloat(parseFloat(totalAmount) * parseFloat(gydPrice)).toFixed(2)}</h6> */}
          </div>
          {/* <p className="text-success fw-bold">Please log into your account to complete this payment.</p> */}
          <div>
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Customer MMG Number</Form.Label>
                <Form.Control
                  type="text"
                  id="customerId"
                  name="customerId"
                  placeholder="MMG number"
                  value={merchantData.customerId}
                  onChange={handleChange}
                  className={`rounded-1 ${isCustomerIdInvalid ? "is-invalid" : ""}`}
                />
                {isCustomerIdInvalid && (
                  <div className="invalid-feedback">
                    Customer MMG number is required.
                  </div>
                )}
              </Form.Group>

              <div className="text-center">
                <Button
                  variant="primary"
                  onClick={MMGPayment}
                  className="rounded-1"
                  disabled={isPaymentInitiated}
                >
                  {isPaymentInitiated ? "Processing..." : "Submit"}
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Note Modal */}
      <Modal
        show={showNoteModal}
        onHide={() => setShowNoteModal(false)}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Important Payment Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            <li>
              You have <strong>10 minutes</strong> to complete the payment.
            </li>
            <li>Please check your MMG account to make the payment.</li>
            <li>Do not initiate multiple payments at the same time.</li>
            <li>
              After 10 minutes, your transaction will be marked as{" "}
              <strong>Rejected</strong> by our system.
            </li>
            <li>
              If you make a payment **after 10 minutes**, the platform will not
              be responsible for any deduction.
            </li>
            <li>
              Don't refresh the page or close the tab during the payment
              process.
            </li>
          </ul>
          <div className="text-center mt-3">
            <h5>
              Time Remaining:{" "}
              <span className="text-danger">
                {formatTime(timeLeft)} Minutes
              </span>
            </h5>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowNoteModal(false)}>
            I Understand
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Fac Modal */}
      <Modal show={Facshow} onHide={handleFacClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title className="fw-semibold lh-1">
            <div>Checkout form</div>{" "}
            <span className="x-small h5">
              Please fill out the form below to complete your purchase.
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="cardholderName">
                  <Form.Label>Cardholder Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter name"
                    id="cardholderName"
                    value={checkoutForm.cardholderName}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("cardholderName")
                        ? "red"
                        : "",
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="cardNumber">
                  <Form.Label>Card Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="XXXX-XXXX-XXXX-XXXX"
                    id="cardNumber"
                    onKeyPress={(event) => {
                      if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={checkoutForm.cardNumber}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("cardNumber")
                        ? "red"
                        : "",
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="expiryDate">
                  <Form.Label>Expiration Date (MMYY)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="MM / YY"
                    id="expiryDate"
                    onKeyPress={(event) => {
                      if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={checkoutForm.expiryDate}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("expiryDate")
                        ? "red"
                        : "",
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="cvv">
                  <Form.Label>Security Code (CVV2)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="XXX"
                    id="cvv"
                    onKeyPress={(event) => {
                      if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                        event.preventDefault();
                      }
                    }}
                    value={checkoutForm.cvv}
                    onChange={handleFACChange}
                    style={{
                      borderColor: emptyFields.includes("cvv") ? "red" : "",
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="amount">
                  <Form.Label>Amount to pay</Form.Label>
                  <Form.Control
                    type="Number"
                    placeholder="e.g. 100.00 USD"
                    id="amount"
                    value={(
                      parseFloat(vehicleDetail.perHourRate) *
                        parseInt(totalBookingHour) +
                      parseFloat(vehicleDetail.securityDeposit)
                    ).toFixed(2)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              variant="primary"
              type="button"
              className="w-100"
              onClick={handleFACPayment}
            >
              Confirm Payment
            </Button>
            <div className="text-center mt-4">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Visa.svg"
                alt="Visa"
                height="30"
                className="mx-2"
              />
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/0/04/Mastercard-logo.png"
                alt="MasterCard"
                height="30"
                className="mx-2"
              />
              <img
                src="images/american_exp.webp"
                alt="AMEX"
                height="30"
                className="mx-2"
              />
            </div>

            <div
              className="text-center mt-2 text-muted"
              style={{ fontSize: "14px" }}
            >
              <p>
                POWERED BY{" "}
                <img
                  src="images/Powertranz-Logo.png"
                  alt="PowerTranz"
                  style={{ height: "23px", verticalAlign: "middle" }}
                />
              </p>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
    // ----------------
  );
};

export default VehiclePayment;
